import * as S from './style';
import { Gallery, Notice, Newsletter, Trend } from '@/api/notice';
import dayjs from 'dayjs';
import { Fragment } from 'react';
import { GetPastConferencesDataType } from '@/api/conference';

export interface ColumnDef {
	key: string;
	title: string;
}

interface TableProps {
	columns: ColumnDef[];
	totalItems: number;
	page: number;
	data: (Gallery | Notice | Newsletter | Trend | GetPastConferencesDataType)[];
	onClick: (pk: number | string) => void;
}

// 동적으로 값 가져오는 함수
const getDynamicValue = <T extends Record<string, any>>(obj: T, key: string) => obj[key] ?? '';

const BoardTable = ({ columns, data, onClick, totalItems, page }: TableProps) => (
	<S.TableContainer>
		<S.Table>
			{columns.map((column, index) => (
				<S.TableHeaderCell key={index}>{column.title}</S.TableHeaderCell>
			))}

			{data.map((row, index) => {
				// 동적으로 pk 가져오기
				const pkKey =
					'gallery_pk' in row
						? 'gallery_pk'
						: 'notice_pk' in row
							? 'notice_pk'
							: 'trend_pk' in row
								? 'trend_pk'
								: 'guide_pk' in row
									? 'guide_pk'
									: 'newsletter_pk';
				const pkValue = getDynamicValue(row, pkKey);

				return (
					<Fragment key={pkValue}>
						{columns.map((column, i) => {
							// 컬럼에 따라 동적으로 처리
							const columnKey = column.key; // column.key에 따라 다르게 처리
							const value = getDynamicValue(row, columnKey);

							// 'no' 컬럼은 인덱스 + 1
							if (columnKey === 'no') {
								if (row?.fixed_yn === '중요') {
									return (
										<S.TableCell key={i}>
											<span className="label_box">중요</span>
										</S.TableCell>
									);
								} else {
									return <S.TableCell key={i}> {totalItems - (page - 1) * 10 - index}</S.TableCell>;
								}
							}

							// 조회수나 날짜에 대한 포맷 처리
							if (columnKey.includes('hit')) {
								return <S.TableCell key={i}>{value === '' ? '0' : value}</S.TableCell>;
							}

							if (columnKey.includes('enrollment_date')) {
								return <S.TableCell key={i}>{dayjs(value).format('YYYY-MM-DD')}</S.TableCell>;
							}
							if (columnKey.includes('title')) {
								return (
									<S.TableCell className="start" key={i} onClick={() => onClick(pkValue)}>
										{value}
									</S.TableCell>
								);
							}
							// 나머지 값은 그대로 출력
							return (
								<S.TableCell key={i} onClick={() => onClick(pkValue)}>
									{value}
								</S.TableCell>
							);
						})}
					</Fragment>
				);
			})}
		</S.Table>
	</S.TableContainer>
);

export default BoardTable;
